import { createBrowserRouter, Navigate } from 'react-router-dom'

import { AppLayout } from '@/app/AppLayout'
import { RequireAuth } from '@/shared/auth/RequireAuth'
import { LoginPage } from '@/features/auth/LoginPage'
import { AddDevicePage } from '@/features/devices/AddDevicePage'
import { DevicePage } from '@/features/devices/DevicePage'
import { DevicesPage } from '@/features/devices/DevicesPage'
import { ConsentPage } from '@/features/mcp/ConsentPage'
import { McpPage } from '@/features/mcp/McpPage'

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  // Consentimento OAuth: autenticado, mas sem a casca (header) — é uma tela de decisão isolada.
  {
    path: '/oauth/consent',
    element: (
      <RequireAuth>
        <ConsentPage />
      </RequireAuth>
    ),
  },
  {
    path: '/',
    element: (
      <RequireAuth>
        <AppLayout />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <Navigate to="/dispositivos" replace /> },
      { path: 'dispositivos', element: <DevicesPage /> },
      { path: 'dispositivos/adicionar', element: <AddDevicePage /> },
      { path: 'dispositivos/:id', element: <DevicePage /> },
      { path: 'mcp', element: <McpPage /> },
      { path: '*', element: <Navigate to="/dispositivos" replace /> },
    ],
  },
])
